import { CHECKOUTFORM_FIELDS } from '@buy/constants'
import { isEmpty, isNull } from 'lodash-es'

export const saveSessionState = (key: string, value: string | number | Record<string, unknown>) => {
    try {
        sessionStorage.setItem(key, JSON.stringify(value))
    } catch (err) {
        // fail silently
    }
}

export const getSessionState = (key: string) => {
    const sessionItem = sessionStorage.getItem(key)
    if (sessionItem) {
        return JSON.parse(sessionItem)
    }
    return ''
}

export const setFormSessionValues = (formValues: Record<string, string | boolean>) => {
    Object.keys(formValues).forEach((key) => {
        sessionStorage?.setItem(key, formValues[key].toString() || '')
    })
}

export const getFormSessionValue = (formKey: CHECKOUTFORM_FIELDS): string => {
    const sessionFormValue = sessionStorage?.getItem(formKey)
    return isNull(sessionFormValue) || isEmpty(sessionFormValue) ? '' : sessionFormValue
}

export const getBooleanFromSessionStorage = (value: string) => {
    return value === 'true'
}
